import api, { formDataInstance } from "./baseRequest";

export const metaDetailsService = {
  getAllMetaDetails: () => api.get("/meta-details"),

  getMetaDetailsByPathname: (pathname) => api.get(`/meta-details/${pathname}`),

  createMetaDetails: (formData) =>
    formDataInstance.post("/meta-details", formData),

  updateMetaDetails: (pathname, formData) =>
    formDataInstance.put(`/meta-details/${pathname}`, formData),
};
